import { render, staticRenderFns } from "./SpaceDetailsEditDialog.vue?vue&type=template&id=1a56e664&"
import script from "./SpaceDetailsEditDialog.vue?vue&type=script&lang=js&"
export * from "./SpaceDetailsEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports